export default __webpack_public_path__ + "static/media/jvaRelatorio.de1e3f7e.png";